import * as React from 'react';
import ILPVSokProps from './ILPVSokProps';
import ILPVSokState from './ILPVSokState';
import Pagination from '../SharedComponents/Pagination/Pagination';
import ResultPane from './ResultPane/ResultPane';
import NoResultPane from '../SharedComponents/NoResultPane/NoResultPane';
import Filter from '../SharedComponents/Filter/Filter';
import SearchBox from '../SharedComponents/SearchBox/SearchBox';
import SearchNavigationTabs from '../SharedComponents/SearchNavigationTabs/SearchNavigationTabs';
import './LPVSok.scss'
import { getFilterNames } from '../../utils'
import IRefiners from '../../Models/IRefiners';
import { DisplayFormat } from '../../Models/DisplayFormat';
import { Resultnumber } from '../SharedComponents/Resultnumber';
import { toggleToTopComponent } from '../SharedComponents/MoveToTop/MoveToTop';
import { SuggestionBox } from '../SharedComponents/SuggestionBox';
import { InformationMessageBox } from '../SharedComponents/InformationMessageBox';
import { getUrlParameter, setUrlParameter, removeAllFilterParams, getFilterParametersFromUrl, removeHashFromUrl } from '../../utils/urlParamHelper';
import { Log, LogWarning } from '../../utils/logging';
import { getResults, SearchQuery, SearchSource } from './getResults';
import { addActiveAndUnactiveFiltersFromUrl, ensureSelectedFilterValues, getNumberOfActiveFilters, emptyFilterCheckboxes, getFilterNamesWithCheckedItems, updateFilterCounts } from '../../utils/refinerHelpers';
import { getInfoMsg } from '../../utils/searchHelpers';
import { getCurrentDisplayFormat } from '../../utils/generalHelpers';
import { subLPInnholdstypeCheckBoxes, subElementerLPInnholdstypeCheckBoxes, subFagkodeInnholdstypeCheckBoxes, subUtdanningsprogramYrkesfagCheckBoxes, subUtdanningsprogramStudieCheckBoxes, subNivaTrinnChechboxOrder, subNivaVgsChechboxOrder, fltypefiltermultiChechboxOrder, nivaChechboxOrder, utdanningsprogramCheckBoxOrder } from '../../utils/sortingLists';
import { ILPVResult } from '../../Models/IResult';
import IResponse from '../../Models/IResponse';
import FiltersSelected from '../SharedComponents/FiltersSelected/FiltersSelected';
import SortBySuggestion from "../SharedComponents/Suggestion/SortBySuggestion";
import { Heading, Button, ListUnordered, ListItem } from '@udir-design/react/beta';
import { ChevronDownIcon, ChevronUpIcon } from '@udir-design/icons';
import '../../udirsok-searchbox-redesign.scss'

export default class LPVSok extends React.Component<ILPVSokProps, ILPVSokState> {
    private resultPerPage = 10;
    private refinementFilters = ['nivaa', 'spraakmaalform', 'fltypefiltermulti', 'status', 'utdanningsprogram','laereplanfagtype'];
    private predefinedFilterNames = ['fltypefiltermulti', 'status'];
    private predefinedFilterDefaults: Record<string, string> = {
        'fltypefiltermulti': 'Læreplan',
        'status': 'Gjeldende'
    };
    private refinementFiltersShowAllValuesUrlParamName = 'filtervalues'; 
    private searchTimout;
    private queryParameter = "query";
    private _queryCounter = 0;

    public constructor(props: ILPVSokProps) {
        super(props);
        // Removing hash (#) from URL if exists
        if(window.location.hash && window.location.hash !== ""){
            removeHashFromUrl(window.location.href);
        }
        //Set up initial querydata from parameters
        let queryParameter = getUrlParameter(this.queryParameter);
        if (getUrlParameter("k") !== undefined) {
            this.queryParameter = "k"
            queryParameter = getUrlParameter(this.queryParameter);
        }
        const initialPageNumber = getUrlParameter('page');
        const filterParameters = getFilterParametersFromUrl(this.refinementFilters);
        const initialSource = getUrlParameter('kilde');
        let enumInitialSource;

        if (!initialSource || initialSource === 'Default') {
            enumInitialSource = SearchSource.Default;
        } else {
            enumInitialSource = SearchSource.All;
        }
        this.state = {
            currentPageNumber: initialPageNumber !== undefined ? Number(initialPageNumber) : 1,
            initialQuery: queryParameter ? queryParameter : '',
            displayFormat: getCurrentDisplayFormat(),
            initialPageNumber: initialPageNumber !== undefined ? Number(initialPageNumber) : undefined,
            initialFilters: filterParameters ? filterParameters : undefined,
            searchSource: enumInitialSource,
            showSearchTips: false,
            isInitialSearch: true
        }
    }

    public componentDidMount() {
        window.addEventListener("resize", _ => this._onWindowResize());
        window.addEventListener("orientationchange", _ => this._onOrientationChange());
        window.onpopstate = () => this.onStatePopped();
        window.addEventListener("pageshow", (event: PageTransitionEvent) => {
            if (event.persisted) {
                window.location.reload();
            }
        });
        this.setupAndRunInitialQuery();
        getInfoMsg().then(result => {
            if(result){
                if(result.læreplan){
                    this.setState({ informationMessage: result.læreplan.title });
                }
                for (var i = 0; i < result.length; i++) {
                    if(result[i].hasOwnProperty("læreplan")){
                        this.setState({ informationMessage: result[i].læreplan.title });
                        break;
                    }
                }
            }
        });
    }

    public componentDidUpdate() {
        toggleToTopComponent(this.state.results && this.state.results.items.length > 0);
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", _ => this._onWindowResize());
        this._onWindowResize();
    }

    public render() {
        const numberOfResults = this.findNumberOfResults();
        const numberOfPages = this.findNumberOfPages();
        const numberOfActiveFilters = getNumberOfActiveFilters(this.state.filter, this.refinementFilters);
        const isDesktop = this.state.displayFormat === DisplayFormat.Desktop;
        const searchboxClass = isDesktop ? "searchBoxBanner filterLeftAligned" : "searchBoxBanner";
        const searchboxClassWithToggle = `${searchboxClass} ${this.state.showSearchTips ? 'tips-open' : 'tips-closed'}`;
        const resultinformationClass = isDesktop ? "searchVerticals" : "searchVerticals";
        const filterClass = "filters";
        const searchresultsClass = "uds-results";
        const shouldDisplayFilters = (this.state.results && this.state.results.items && this.state.results.items.length > 0) ||
            (this.state.filter && getNumberOfActiveFilters(this.state.filter, this.refinementFilters) > 0);
        const showAutocomplete = true;
        return (
            <div id="main-content" className="searchContainer">
                <div className='searchBoxBannerOuter'>
                    <div className={`${searchboxClassWithToggle}`}>
                        <div className="searchBoxBannerContent">
                            <div className="searchBoxContent">
                                <div className="leftBarSearchBox">
                                    <div className="searchHeader">
                                        <Heading className='searchText' level={1} data-size={isDesktop ? 'lg' : 'md'}>
                                            Søk i læreplaner
                                        </Heading>
                                    </div>
                                    <SearchBox
                                        searchAsYouType={!showAutocomplete}
                                        initialQuery={this.state.initialQuery ? this.state.initialQuery : ""}
                                        onSearch={(query, searchAsYouType) => this.onSearch(query, searchAsYouType)}
                                        newQuery={this.state.newStateQuery}
                                        placeholderText="Søk etter læreplaner og fagkoder"
                                        autocomplete={showAutocomplete}
                                        searchVertical="Laereplan" />

                                </div>
                                <div className="rightBarSearchBox">
                                    {/* 
                                    <Button
                                        variant='tertiary'
                                        color='neutral'
                                        className="SearchTipsButton"
                                        onClick={() => this.setState({ showSearchTips: !this.state.showSearchTips })}
                                        aria-expanded={!!this.state.showSearchTips}
                                        aria-controls="SearchTipsContent"
                                    >
                                        Søketips
                                        {this.state.showSearchTips ? <ChevronUpIcon /> : <ChevronDownIcon />}
                                    </Button>
                                    {this.state.showSearchTips && (
                                        <div className="SearchTipsContent" id="SearchTipsContent">
                                            <div className='SearchTipsContentText'>
                                                <ListUnordered>
                                                    <ListItem>
                                                        Man kan angi flere ord innenfor anførselsestegn («…») for å søke etter disse ordene i den bestemte, angitte rekkefølgen. For eksempel søk på «læreplan i norsk» for å finne søketreff med ordene i nøyaktig den rekkefølgen.
                                                    </ListItem>
                                                    <ListItem>
                                                        Man kan bruke - for å ekskludere ord. For eksempel søke på: <em>rapporter -årsrapporter</em> for å finne alle treff med rapporter som ikke har med ordet årsrapporter
                                                    </ListItem>
                                                </ListUnordered>
                                            </div>
                                        </div>
                                    )}
                                    */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={`${resultinformationClass}`}>
                    <SearchNavigationTabs currentTab="lareplan" searchQuery={this.state.searchboxQuery} />
                    {!isDesktop && shouldDisplayFilters && this.state.filter && (
                        <Filter
                            getFilterDisplayName={(refinerKey: string) => this.getFilterDisplayName(refinerKey)}
                            refiners={this.state.filter}
                            onFilterSelected={this.onFilterChanged.bind(this)}
                            onAllFilterClicked={this.onAllFilterClicked.bind(this)}
                            displayFormat={this.state.displayFormat}
                            source={this.state.searchSource}
                            initialOpenFilterNames={['fltypefiltermulti', 'status', ...getFilterNamesWithCheckedItems(this.state.filter)]}
                            onSourceChanged={(searchSource: SearchSource) => { this.updateSearchSource(searchSource) }}
                        />
                    )}
                    {!isDesktop && numberOfActiveFilters > 0 && (numberOfResults > 0 || this.state.results?.items.length === 0) && !(this.state.searchWithoutFiltersHasResults && this.state.isInitialSearch) && <FiltersSelected filters={getFilterParametersFromUrl(this.refinementFilters)} isDesktop={isDesktop} emptyFilters={() => this.emptyFilters()} onRemoveFilter={this.onRemoveFilter} />}
                </div>
                <div className="resultContainer">
                    
                    <div className='filters-and-results'>
                        {isDesktop && (
                            <div className={`${filterClass}`}>
                                {shouldDisplayFilters
                                    && this.state.filter
                                    && <Filter
                                        getFilterDisplayName={(refinerKey: string) => this.getFilterDisplayName(refinerKey)}
                                        refiners={this.state.filter}
                                        onFilterSelected={this.onFilterChanged.bind(this)}
                                        onAllFilterClicked={this.onAllFilterClicked.bind(this)}
                                        displayFormat={this.state.displayFormat}
                                        source={this.state.searchSource}
                                        initialOpenFilterNames={['fltypefiltermulti', 'status', ...getFilterNamesWithCheckedItems(this.state.filter)]}
                                        onSourceChanged={(searchSource: SearchSource) => { this.updateSearchSource(searchSource) }}
                                        filterChips={numberOfActiveFilters > 0 ? <FiltersSelected filters={getFilterParametersFromUrl(this.refinementFilters)} isDesktop={isDesktop} emptyFilters={() => this.emptyFilters()} onRemoveFilter={this.onRemoveFilter} /> : undefined} />}
                            </div>
                        )}
                        <div className={`${searchresultsClass}`}>
                            <InformationMessageBox
                                isDesktop={isDesktop}
                                currentPage="Læreplaner"
                                informationMessage={this.state.informationMessage}
                            />
                            <SuggestionBox
                                query={this.state.query}
                                searchboxQuery={this.state.searchboxQuery}
                                erronousQuery={this.state.erronousQuery}
                                querySuggestion={this.state.querySuggestion}
                                emptyFilters={() => this.emptyFilters()}
                                initialFilters={this.state.initialFilters}
                                refinementFilters={this.refinementFilters}
                                searchWithoutFiltersHasResults={this.state.searchWithoutFiltersHasResults}
                                isSearchingWithDeactivatedFilters={this.state.isSearchingWithDeactivatedFilters}
                                results = {this.state.results}
                                predefinedFilterLabel = "gjeldende læreplaner"
                                isInitialSearch = {this.state.isInitialSearch}
                            />
                            {this.state.results && this.state.results.items.length === 0 && this.state.query && (() => {
                                let currentFilters = getFilterParametersFromUrl(this.refinementFilters);
                                return <NoResultPane onSearchClearFilters={(query) => this.onSearchClearFilters(query)} searchQuery={this.state.query} filters={getFilterNames(currentFilters ? currentFilters : [])} />
                            })()}
                            {numberOfResults > 0 && (
                            <div className="numresults-sortby">
                                <Resultnumber currentPageNumber={this.state.currentPageNumber} isDesktop={isDesktop} numberOfResults={numberOfResults} resultPerPage={this.resultPerPage} searchQuery={this.state.searchboxQuery || this.state.query} />
                                {/*numberOfResults > 0 && (
                                <div className="results-sortby-suggestion">
                                    <SortBySuggestion
                                        currentTab="lareplan"
                                        searchQuery={this.state.query}
                                        onSortChange={this.onSortChanged}
                                    />
                                </div>
                            )*/}
                            </div>
                            )}
                            
                            {this.state.results && this.state.results.items.length > 0 && <ResultPane results={this.state.results.items as ILPVResult[]} queryText={this.state.results.queryText} />}
                            {numberOfPages > 1 && <Pagination currentPage={this.state.currentPageNumber} numberOfPages={numberOfPages} onPageChanged={(newPageNumber) => this.onPageChanged(newPageNumber)} searchQuery={this.state.searchboxQuery} />}
                            {/*<MoveToTop />*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private getFilterDisplayName = (refinerKey: string) => {
        switch (refinerKey) {
            case 'nivaa':
                return 'Trinn/nivå';
            case 'spraakmaalform':
                return 'Språk';
            case 'status':
                return 'Gyldighet';
            case 'publisertstatus':
                return 'Gyldighet';
            case 'innholdstypefilter':
                return 'Type innhold';
            case 'fltypefilter':
                return 'Type innhold';
            case 'fltypefiltermulti':
                return 'Type innhold';
            case 'utdanningsprogram':
                return 'Utdanningsprogram'
            case 'laereplanfagtype':
                return 'Fagtype'
            default:
                return refinerKey;
        };
    }

    private renderResultPane() {
        if (!this.state.results) return null
        if (this.state.results.items.length === 0) {
            if (!this.state.query) return null;
            let currentFilters = getFilterParametersFromUrl(this.refinementFilters);
            return <NoResultPane onSearchClearFilters={(query) => this.onSearchClearFilters(query)} searchQuery={this.state.query} filters={getFilterNames(currentFilters ? currentFilters : [])} />
        }
        return <ResultPane results={this.state.results.items as ILPVResult[]} queryText={this.state.results.queryText} />;
    }

    private async setupAndRunInitialQuery() {
        let pageNumber = this.state.initialPageNumber ? this.state.initialPageNumber : 1;
        let initialFilters: any[] | undefined = this.state.initialFilters;
        let initialQuery: string = this.state.initialQuery ? this.state.initialQuery : '*';
        const initialSource = this.state.searchSource ? this.state.searchSource : SearchSource.Default;
        Log(initialSource);
        if (initialQuery !== '*') {
            setUrlParameter(document.location.href, this.queryParameter, initialQuery, true); //We do not set window.history on first load.
        }
        if (this.state.initialFilters && this.state.initialFilters.length > 0) {
            initialFilters = getFilterParametersFromUrl(this.refinementFilters);
        }
        this.setState({
            searchboxQuery: SearchBox.getSearchBoxQuery(),
            newStateQuery: undefined,
            currentPageNumber: pageNumber
        });

        // Checking if search should expand with all available filter values (used for predefined searches) 
        const filterValuesUrlParam = getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName);
        if(filterValuesUrlParam && filterValuesUrlParam.toLowerCase() === "all"){
            const query: SearchQuery = {
                queryString: initialQuery,
                pageNumber: pageNumber,
                refiners: initialFilters,
                source: this.state.searchSource
            };
            const allResults = await getResults(query);
            if (allResults && allResults.totalResults > 0) {
                // Filtered search has results — show them with all filter options
                let urlFilters = getFilterParametersFromUrl(this.refinementFilters);
                const remappedFilters = await this.buildFiltersDisjunctive(allResults, urlFilters, query.queryString, pageNumber, this.state.searchSource);
                
                this.setState({
                    filter: remappedFilters,
                    results: allResults,
                    query: query.queryString,
                    isSearchingWithDeactivatedFilters: false,
                    searchSource: this.state.searchSource,
                    searchWithoutFiltersHasResults: false,
                    querySuggestion: undefined
                });
            } else if (!this.hasUserSelectedFilters()) {
                // 0 results with only predefined filters — remove them and search without
                removeAllFilterParams(window.location.href, this.refinementFilters);
                const resultsNoFilter = await getResults({
                    queryString: query.queryString,
                    pageNumber: pageNumber,
                    source: this.state.searchSource
                });
                if (resultsNoFilter && resultsNoFilter.totalResults > 0) {
                    this.setState({
                        filter: resultsNoFilter.refiners,
                        results: resultsNoFilter,
                        query: query.queryString,
                        isSearchingWithDeactivatedFilters: false,
                        searchWithoutFiltersHasResults: true,
                        querySuggestion: undefined,
                        currentPageNumber: pageNumber,
                        initialFilters: undefined
                    });
                } else {
                    // No results at all
                    this.setState({
                        results: resultsNoFilter,
                        query: query.queryString,
                        searchWithoutFiltersHasResults: true,
                        initialFilters: undefined
                    });
                }
            } else {
                // 0 results with user-selected filters — show 0 results, no fallback
                this.setState({
                    results: allResults,
                    query: query.queryString,
                    searchWithoutFiltersHasResults: false
                });
            }
        }else{
            await this.runQuery(initialQuery, false, initialSource, pageNumber, initialFilters, true);
        }
    }

    private onSearch(query: string, searchAsYouType: boolean) {
        let urlFilters = getFilterParametersFromUrl(this.refinementFilters);
        let searchboxQuery = SearchBox.getSearchBoxQuery();

        let currentPageUrl = getUrlParameter('page');
        if (currentPageUrl) {
            setUrlParameter(window.location.href, 'page', '');
        }
        
        // Remove filtervalues=all from URL when user searches - we handle filter preservation in runQuery
        if (getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName) === "all") {
            setUrlParameter(window.location.href, this.refinementFiltersShowAllValuesUrlParamName, '');
        }

        this.setState({
            query: query,
            searchboxQuery: searchboxQuery,
            currentPageNumber: 1,
            isInitialSearch: false
        });
        
        // When searching with active filters, we want to preserve all filter options
        const hasFilters = urlFilters && urlFilters.length > 0;
        
        if (hasFilters) {
            this.runQuery(query, false, this.state.searchSource, 1, urlFilters, false, true); // preserveFilters = true
        } else {
            this.runQuery(query, false, this.state.searchSource, 1);
        }

        //Only update when user have initiated a search from a action, not type as you search
        if (searchAsYouType === true) {
            clearTimeout(this.searchTimout);
            this.searchTimout = window.setTimeout(() => {
                setUrlParameter(window.location.href, this.queryParameter, query);
            }, 1000);
        } else {
            setUrlParameter(window.location.href, this.queryParameter, query);
        }

    }

    private onSearchClearFilters(query: string) {
        //Clear all the url-params
        this.refinementFilters.forEach(refinementFilter => {
            setUrlParameter(window.location.href, refinementFilter, '');
        });
        this.onSearch(query, false);
    }

    private onPageChanged(newPageNumber: number) {
        let filter = this.state.filter ? this.state.filter : undefined;
        if (this.state.query) {
            this.runQuery(this.state.query, false, this.state.searchSource, newPageNumber, filter);
            setUrlParameter(window.location.href, 'page', newPageNumber);
            this.setState({
                currentPageNumber: newPageNumber
            });
            //Scroll to top
            window.scrollTo(0, 0);
        } else if (this.state.query === "" && this.state.results && this.state.results.totalResults > 10) {
            this.runQuery("*", false, this.state.searchSource, newPageNumber, filter);
            setUrlParameter(window.location.href, 'page', newPageNumber);
            this.setState({
                currentPageNumber: newPageNumber
            });
            window.scrollTo(0, 0);
        }
    }

    private remapFilters(fetchedRefiners: IRefiners[], initFilter: any[] | undefined, selectedFilter: string) {
        if (initFilter && initFilter.length > 0) {
            this.refinementFilters.forEach(filterName => {
                let currentInitFilter = initFilter.filter(val => val.Name === filterName)[0];

                if (currentInitFilter && fetchedRefiners) {
                    let currentFetchedFilter = fetchedRefiners.filter(val => val.Name === filterName)[0];
                    if (currentFetchedFilter) {
                        currentFetchedFilter.Entries.forEach(refiner => {
                            const matchedEntry = currentInitFilter.Entries.filter(val => val.RefinementToken === refiner.RefinementToken)[0];
                            refiner.checked = matchedEntry !== undefined;
                        });
                    }
                }
            });
        }
        return fetchedRefiners;
    }

    /**
     * Update refiner counts with disjunctive-like faceting.
     * For refiners WITHOUT checked entries: use counts from filteredResults (correct cross-refiner AND logic).
     * For refiners WITH checked entries: make a separate API call excluding that refiner's filter,
     * so we get accurate counts for all values in that refiner.
     * Also applies visibility logic (hidden, fakeChecked) and parent sum recalculation.
     * Uses filteredResults.refiners as the base — no separate unfiltered search needed.
     */
    private async buildFiltersDisjunctive(
        filteredResults: IResponse,
        filterParams: any[],
        queryString: string,
        pageNumber: number,
        source: SearchSource
    ): Promise<IRefiners[]> {
        if (!filteredResults.refiners) return [];

        // Determine which refiner names have checked entries
        const checkedRefinerNames = new Set<string>(
            filterParams ? filterParams.map(p => p.Name) : []
        );

        // Deep copy refiners from filtered results as starting point
        let filters: IRefiners[] = JSON.parse(JSON.stringify(filteredResults.refiners));

        // Ensure refiners that are checked in URL but missing from filteredResults
        // (typical when filtered search returns 0 results and SP returns no buckets
        // for some refiners) are still included — otherwise the disjunctive calls
        // below will be missing those filters and produce inflated counts.
        if (filterParams && filterParams.length > 0) {
            filterParams.forEach(urlFilter => {
                const exists = filters.find(r => r.Name === urlFilter.Name);
                if (!exists) {
                    filters.push({
                        Name: urlFilter.Name,
                        Entries: urlFilter.Entries.map(e => ({ ...e, checked: true }))
                    } as IRefiners);
                }
            });
        }

        // Set checked property from filterParams
        if (filterParams && filterParams.length > 0) {
            this.refinementFilters.forEach(filterName => {
                const urlFilter = filterParams.find(p => p.Name === filterName);
                const refiner = filters.find(r => r.Name === filterName);
                if (refiner) {
                    refiner.Entries.forEach(entry => {
                        entry.checked = urlFilter
                            ? urlFilter.Entries.some(e => e.RefinementToken === entry.RefinementToken)
                            : false;
                    });
                }
            });
        }

        // For each refiner with checked entries: make disjunctive API call and replace entries
        for (const refinerName of Array.from(checkedRefinerNames)) {
            // Build filters with all refiners EXCEPT this one checked
            const filtersExcludingThisRefiner = filters.map(r => ({
                ...r,
                Entries: r.Entries.map(e => ({
                    ...e,
                    checked: r.Name === refinerName ? false : e.checked
                }))
            }));

            const disjunctiveResults = await getResults({
                queryString,
                pageNumber,
                refiners: filtersExcludingThisRefiner,
                source
            });

            if (disjunctiveResults.refiners) {
                const disjunctiveRefiner = disjunctiveResults.refiners.find(r => r.Name === refinerName);
                if (disjunctiveRefiner) {
                    // Set checked on the disjunctive entries from URL params
                    const urlFilter = filterParams.find(p => p.Name === refinerName);
                    disjunctiveRefiner.Entries.forEach(entry => {
                        entry.checked = urlFilter
                            ? urlFilter.Entries.some(e => e.RefinementToken === entry.RefinementToken)
                            : false;
                    });
                    // Add checked entries that are missing from API results (0 count)
                    if (urlFilter) {
                        urlFilter.Entries.forEach(urlEntry => {
                            const exists = disjunctiveRefiner.Entries.some(e =>
                                e.RefinementToken === urlEntry.RefinementToken ||
                                e.RefinementValue === urlEntry.RefinementValue ||
                                e.RefinementName === urlEntry.RefinementName
                            );
                            if (!exists) {
                                const newEntry: any = {
                                    RefinementCount: '0',
                                    RefinementName: urlEntry.RefinementName,
                                    RefinementToken: urlEntry.RefinementToken,
                                    RefinementValue: urlEntry.RefinementValue,
                                    checked: true
                                };
                                // Set hierarchy metadata so the entry keeps its position
                                this.applyRefinerHierarchy(refinerName, newEntry);
                                disjunctiveRefiner.Entries.push(newEntry);
                            }
                        });
                    }
                    // Re-sort entries to maintain correct order
                    this.sortRefinerEntries(refinerName, disjunctiveRefiner);
                    // Replace the refiner in the filter list
                    const idx = filters.findIndex(r => r.Name === refinerName);
                    if (idx !== -1) {
                        filters[idx] = disjunctiveRefiner;
                    } else {
                        filters.push(disjunctiveRefiner);
                    }
                }
            }
        }

        // For unchecked refiners: counts from filteredResults are already correct (cross-refiner AND logic)

        // Apply parent/child visibility logic
        filters.forEach(refiner => {
            // Ensure all level 0 entries (parents) and entries without parent are visible
            refiner.Entries.forEach(entry => {
                if (entry.level === 0 || !entry.parent) {
                    entry.hidden = false;
                }
            });

            // Set fakeChecked on parents and unhide children when entries are checked
            const checkedEntries = refiner.Entries.filter(entry => entry.checked === true);
            if (checkedEntries.length > 0) {
                refiner.Entries.forEach(entry => {
                    const isParent = checkedEntries.some(checkedEntry =>
                        entry.RefinementName === checkedEntry.parent && checkedEntry.parent !== undefined
                    );
                    const hasSameParent = checkedEntries.some(checkedEntry =>
                        checkedEntry.parent === entry.parent
                    );
                    if (isParent) {
                        entry.fakeChecked = true;
                    }
                    if (hasSameParent && entry.parent !== undefined) {
                        entry.hidden = false;
                    }
                });
            }

            // Unhide children when parent is checked or fakeChecked
            refiner.Entries.forEach(entry => {
                if ((entry.checked || entry.fakeChecked) && entry.level === 0) {
                    refiner.Entries.forEach(child => {
                        if (child.parent === entry.RefinementName) {
                            child.hidden = false;
                        }
                    });
                }
            });
        });

        // Recalculate checked/fakeChecked parent counts as sum of children's counts
        filters.forEach(refiner => {
            refiner.Entries.forEach(entry => {
                if (entry.level === 0 && (entry.checked || entry.fakeChecked)) {
                    const children = refiner.Entries.filter(child => child.parent === entry.RefinementName && child.level === 1);
                    if (children.length > 0) {
                        const sum = children.reduce((acc, child) => acc + parseInt(child.RefinementCount || "0", 10), 0);
                        entry.RefinementCount = String(sum);
                    }
                }
            });
        });

        return filters;
    }

    /** Sets level, parent, indentation, hidden on a refiner entry based on known hierarchy lists. */
    private applyRefinerHierarchy(refinerName: string, entry: any) {
        const name = entry.RefinementName;
        if (refinerName === 'fltypefiltermulti') {
            if (subLPInnholdstypeCheckBoxes.indexOf(name) !== -1) {
                entry.level = 1; entry.parent = 'Læreplan'; entry.indentation = true; entry.hidden = true;
            } else if (subElementerLPInnholdstypeCheckBoxes.indexOf(name) !== -1) {
                entry.level = 1; entry.parent = 'Elementer i læreplanen LK20'; entry.indentation = true; entry.hidden = true;
            } else if (subFagkodeInnholdstypeCheckBoxes.indexOf(name) !== -1) {
                entry.level = 1; entry.parent = 'Fagkode'; entry.indentation = true; entry.hidden = true;
            } else {
                entry.level = 0;
            }
        } else if (refinerName === 'utdanningsprogram') {
            if (subUtdanningsprogramYrkesfagCheckBoxes.indexOf(name) !== -1) {
                entry.level = 1; entry.parent = 'VGO yrkesfag LK20'; entry.indentation = true; entry.hidden = true;
            } else if (subUtdanningsprogramStudieCheckBoxes.indexOf(name) !== -1) {
                entry.level = 1; entry.parent = 'VGO studieforberedende LK20'; entry.indentation = true; entry.hidden = true;
            } else {
                entry.level = 0;
            }
        } else if (refinerName === 'nivaa') {
            if (subNivaTrinnChechboxOrder.indexOf(name) !== -1) {
                entry.level = 1; entry.parent = '1-10. trinn'; entry.indentation = true; entry.hidden = true;
            } else if (subNivaVgsChechboxOrder.indexOf(name) !== -1) {
                entry.level = 1; entry.parent = 'Vg1-3'; entry.indentation = true; entry.hidden = true;
            } else {
                entry.level = 0;
            }
        }
    }

    /** Re-sorts entries of a refiner using the known sort order lists. */
    private sortRefinerEntries(refinerName: string, refiner: IRefiners) {
        const orderMap: Record<string, string[]> = {
            'fltypefiltermulti': fltypefiltermultiChechboxOrder,
            'nivaa': nivaChechboxOrder,
            'utdanningsprogram': utdanningsprogramCheckBoxOrder,
        };
        const orderList = orderMap[refinerName];
        if (orderList) {
            refiner.Entries.sort((a, b) => {
                const aIdx = orderList.indexOf(a.RefinementName);
                const bIdx = orderList.indexOf(b.RefinementName);
                if (aIdx !== -1 && bIdx !== -1) return aIdx - bIdx;
                if (aIdx === -1 && bIdx === -1) return a.RefinementName.localeCompare(b.RefinementName);
                if (aIdx === -1) return 1;
                return -1;
            });
        }
    }

    private async runQuery(queryString: string, isRerun: boolean, source: SearchSource, pageNumber?: number, filter?: IRefiners[], isInitialQuery?: boolean, preserveFilters?: boolean) {
        const queryId = ++this._queryCounter;
        if (!filter && !preserveFilters) {
            filter = this.state.filter;
        }
        let _pageNumber = pageNumber !== undefined ? pageNumber : 1;
        let query: SearchQuery = {
            queryString: queryString,
            pageNumber: _pageNumber,
            refiners: filter,
            source: source
        }
        let results = await getResults(query);
        // Discard stale results if a newer query has been started
        if (queryId !== this._queryCounter) return;
        let resultsNoFilter;
        
        // Getting all results without filters if filtervalues=all found in url
        let allResultsNoFilters;
        let useAllResultsNoFilters = false;
        const filterValuesUrlParam = getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName);
        if(filterValuesUrlParam && filterValuesUrlParam.toLowerCase() === "all"){
            const queryNoFilter: SearchQuery = {
                queryString: queryString,
                pageNumber: _pageNumber,
                source: source
            };
            allResultsNoFilters = await getResults(queryNoFilter);
            if (queryId !== this._queryCounter) return;
            useAllResultsNoFilters = true;
        }

        if (results.spellingSuggestion !== undefined && results.spellingSuggestion !== queryString && results.spellingSuggestion.length > 0 && results.items.length === 0) {

            // Before using spelling suggestion, check if original query has results without filters
            const urlFilterParams = getFilterParametersFromUrl(this.refinementFilters);
            if (urlFilterParams && urlFilterParams.length > 0) {
                const resultsWithoutFilters = await getResults({
                    queryString: queryString,
                    pageNumber: _pageNumber,
                    source: source
                });
                if (queryId !== this._queryCounter) return;
                if (resultsWithoutFilters && resultsWithoutFilters.totalResults > 0) {
                    // Original query has results without filters — prefer that over spelling correction
                    const hasUserFilters = this.hasUserSelectedFilters();
                    if (!hasUserFilters) {
                        removeAllFilterParams(window.location.href, this.refinementFilters);
                        this.setState({
                            filter: resultsWithoutFilters.refiners,
                            results: resultsWithoutFilters,
                            query: queryString,
                            isSearchingWithDeactivatedFilters: false,
                            searchWithoutFiltersHasResults: true,
                            querySuggestion: undefined,
                            erronousQuery: undefined,
                            initialFilters: undefined
                        });
                    } else {
                        // User has actively chosen non-predefined filters — show 0 results with filter info
                        const remapped = this.remapFilters(resultsWithoutFilters.refiners, urlFilterParams, "");
                        this.setState({
                            filter: remapped,
                            results: results,
                            query: queryString,
                            searchWithoutFiltersHasResults: false,
                            querySuggestion: undefined,
                            erronousQuery: undefined,
                        });
                    }
                    return;
                }
            }

            //Run again with querysuggestion
            this.setState({
                querySuggestion: results.spellingSuggestion,
                erronousQuery: queryString
            });
            this.runQuery(results.spellingSuggestion, true, source, pageNumber, filter);
            return;

        } else if (!results.spellingSuggestion && results.items.length === 0 && source === SearchSource.Default) {
            const hasUserFilters = this.hasUserSelectedFilters();

            if (!isInitialQuery && hasUserFilters) {
                // User has actively chosen non-predefined filters — show 0 results, no fallback.
                // Use unfiltered results to build disjunctive filter panel with accurate counts.
                resultsNoFilter = await getResults({
                    queryString: query.queryString,
                    pageNumber: _pageNumber,
                    source: source
                });
                if (queryId !== this._queryCounter) return;
                const urlFilters = getFilterParametersFromUrl(this.refinementFilters);
                // Use resultsNoFilter as base — filtered results with 0 items often have no refiners
                const baseResults = (resultsNoFilter && resultsNoFilter.totalResults > 0) ? resultsNoFilter : results;
                const disjunctiveFilters = baseResults.refiners
                    ? await this.buildFiltersDisjunctive(baseResults, urlFilters, queryString, _pageNumber, source)
                    : this.remapFilters(results.refiners || [], urlFilters, "");
                if (queryId !== this._queryCounter) return;
                this.setState({
                    filter: disjunctiveFilters,
                    results: results,
                    query: queryString,
                    searchWithoutFiltersHasResults: false,
                    querySuggestion: isRerun ? this.state.querySuggestion : undefined,
                });
            } else {
                // No user-selected filters (only predefined) — try unfiltered first, then SearchSource.All
                resultsNoFilter = await getResults({
                    queryString: query.queryString,
                    pageNumber: _pageNumber,
                    source: source
                });
                if (queryId !== this._queryCounter) return;
                if (resultsNoFilter && resultsNoFilter.totalResults > 0) {
                    // Unfiltered search has results — remove predefined filter params and show "uten filtervalg"
                    removeAllFilterParams(window.location.href, this.refinementFilters);
                    this.setState({
                        filter: resultsNoFilter.refiners,
                        results: resultsNoFilter,
                        query: queryString,
                        isSearchingWithDeactivatedFilters: false,
                        searchWithoutFiltersHasResults: true,
                        querySuggestion: isRerun ? this.state.querySuggestion : undefined,
                        initialFilters: undefined
                    });
                } else {
                    // No results without filters either — try SearchSource.All as last resort
                    let allResults = await getResults({
                        queryString: query.queryString,
                        pageNumber: _pageNumber,
                        refiners: filter,
                        source: SearchSource.All
                    });
                    if (queryId !== this._queryCounter) return;
                    if (allResults && allResults.totalResults > 0) {
                        this.setState({
                            filter: filter,
                            results: allResults,
                            query: queryString,
                            isSearchingWithDeactivatedFilters: true,
                            searchSource: SearchSource.All,
                            searchWithoutFiltersHasResults: false,
                            querySuggestion: isRerun ? this.state.querySuggestion : undefined
                        });
                    } else {
                        // No results at all — remove predefined filters from URL and clear any
                        // checked state on the filter refiners so the filter panel/chips don't
                        // render as if the predefined filters were still selected.
                        removeAllFilterParams(window.location.href, this.refinementFilters);
                        const clearedFilter = (filter || []).map(refiner => ({
                            ...refiner,
                            Entries: (refiner.Entries || []).map(entry => ({ ...entry, checked: false }))
                        }));
                        this.setState({
                            filter: clearedFilter,
                            results: results,
                            query: queryString,
                            querySuggestion: isRerun ? this.state.querySuggestion : undefined,
                            searchWithoutFiltersHasResults: true,
                            initialFilters: undefined
                        })
                    }
                }
            }

        } else {
            
            //Found results, setting all the proper variables.
            const hasNoFilterResults = allResultsNoFilters && allResultsNoFilters.totalResults > 0;
            const hasFilterResults = results && results.totalResults > 0;
            const onlySearchWithoutFiltersHasResults = hasNoFilterResults && !hasFilterResults;

            const setStateObject = {
                results: onlySearchWithoutFiltersHasResults ? allResultsNoFilters : results,
                searchWithoutFiltersHasResults: onlySearchWithoutFiltersHasResults,
            };
            if (preserveFilters) {
                const currentFilterParams = getFilterParametersFromUrl(this.refinementFilters);
                setStateObject['filter'] = await this.buildFiltersDisjunctive(results, currentFilterParams, queryString, _pageNumber, source);
            } else if (isInitialQuery) {
                Log("isInitialQuery if");
                setStateObject['filter'] = await this.buildFiltersDisjunctive(results, this.state.initialFilters || [], queryString, _pageNumber, source);
            } else if (useAllResultsNoFilters) {
                Log("isInitialQuery else if");
                setStateObject['filter'] = this.remapFilters(allResultsNoFilters.refiners, getFilterParametersFromUrl(this.refinementFilters), "");
            } else {
                Log("isInitialQuery else");
                // Check if there are any checked filters in the current state
                const currentFilterParams = getFilterParametersFromUrl(this.refinementFilters);
                const hasCheckedFilters = currentFilterParams && currentFilterParams.length > 0;
                
                if (hasCheckedFilters) {
                    setStateObject['filter'] = await this.buildFiltersDisjunctive(results, currentFilterParams, queryString, _pageNumber, source);
                } else {
                    setStateObject['filter'] = this.remapFilters(results.refiners, currentFilterParams, "");
                }
            }
            setStateObject['isSearchingWithDeactivatedFilters'] = false;
            setStateObject['query'] = queryString;
            if (!isRerun) {
                setStateObject['querySuggestion'] = undefined
            }
            setStateObject['currentPageNumber'] = _pageNumber;

            if (queryId !== this._queryCounter) return;
            this.setState(setStateObject);
        }
    }

    private findNumberOfPages() {
        if (!this.state.results || !this.state.results.totalResults) {
            return 1;
        }
        return Math.ceil(this.findNumberOfResults() / this.resultPerPage);
    }

    private findNumberOfResults() {
        if (!this.state.results) {
            return 0;
        }
        return this.state.results.totalResults
    }

    private async onFiltersChanged(refinementFiltersInUrl: any, pageInUrl:number = 1) {
        let currentFilter = this.state.filter;
        let pageNumber = pageInUrl;

        if (!currentFilter) {
            return
        }
        
        const queryString = this.state.query ? this.state.query : '';
        const query: SearchQuery = {
            queryString: queryString,
            pageNumber: pageNumber,
            refiners: refinementFiltersInUrl,
            source: this.state.searchSource
        };

        const newResults = await getResults(query);
        
        // For selected filters in URL param - set active filters checked
        let filtersToSetActive = getFilterParametersFromUrl(this.refinementFilters);
        let activeFilters = addActiveAndUnactiveFiltersFromUrl(this.state.filter, filtersToSetActive, newResults.refiners);
        
        this.setState({
            results: newResults,
            filter: activeFilters,
            currentPageNumber: 1,
            query: queryString,
            querySuggestion: undefined,
            //previousFilters: newPreviousFiltersToSave
        });
        
    }

    private async onFilterChanged(refinerName: string, refinerIndex: number, reRender?: boolean) {
        let currentFilter = this.state.filter;
        if (!currentFilter) {
            return
        }
        if(getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName) === "all"){
            setUrlParameter(window.location.href, this.refinementFiltersShowAllValuesUrlParamName, '');
        }
        let previousFilters = this.state.previousFilters;
        let currentFilterSelection = currentFilter.filter(filter => filter.Name === refinerName)[0].Entries[refinerIndex];
        const isCurrentlyActive = currentFilterSelection.checked || currentFilterSelection.fakeChecked;
        const newCheckedValue = !isCurrentlyActive;

        currentFilterSelection.checked = newCheckedValue;
        currentFilterSelection.fakeChecked = false;

        let currentFilterUrlParam = getUrlParameter(refinerName);
        let newFilterParamValue = `${currentFilterSelection.RefinementValue}`;
        let newFilterUrlParam = '';
        if (currentFilterSelection.checked) {
            if (currentFilterUrlParam) {
                newFilterUrlParam = `${currentFilterUrlParam};${newFilterParamValue}`;
            } else {
                newFilterUrlParam = newFilterParamValue;
            }
        } else {
            if (currentFilterUrlParam) {
                newFilterUrlParam = currentFilterUrlParam
                    .split(';')
                    .filter(val => val !== newFilterParamValue)
                    .join(';');
            }
        }
        setUrlParameter(window.location.href, refinerName, newFilterUrlParam);

        const queryString = this.state.query ? this.state.query : '';
        const query: SearchQuery = {
            queryString: queryString,
            pageNumber: 1,
            refiners: currentFilter,
            source: this.state.searchSource
        };
        const newResults = await getResults(query);

        // Check if there are still checked filters after this change
        const currentFilterParams = getFilterParametersFromUrl(this.refinementFilters);
        const hasCheckedFilters = currentFilterParams && currentFilterParams.length > 0;
        
        let nextFilter;
        if (hasCheckedFilters) {
            // If filtered results have no refiners (0 results), fall back to unfiltered search for refiner base
            let baseForDisjunctive = newResults;
            if (!newResults.refiners || newResults.refiners.length === 0) {
                const unfilteredResults = await getResults({
                    queryString: queryString,
                    pageNumber: 1,
                    source: this.state.searchSource
                });
                if (unfilteredResults && unfilteredResults.refiners && unfilteredResults.refiners.length > 0) {
                    baseForDisjunctive = unfilteredResults;
                }
            }
            nextFilter = await this.buildFiltersDisjunctive(baseForDisjunctive, currentFilterParams, queryString, 1, this.state.searchSource);
        } else {
            // No filters checked - use results directly
            nextFilter = this.remapFilters(newResults.refiners, currentFilterParams, refinerName);
        }

        let newPreviousFiltersToSave;
        if (!newCheckedValue) {
            if (previousFilters) {
                previousFilters = previousFilters.filter(filter => filter.Name !== refinerName);
                previousFilters.filter(filter => filter.Name !== refinerName).forEach(prevFilter => {
                    try{
                        nextFilter.filter(NF => (NF.Name === prevFilter.Name) !== null)[0].Entries = prevFilter.Entries;
                    }catch{
                        LogWarning("Could not set nextFilter.filter.");
                    }
                });
                newPreviousFiltersToSave = previousFilters;
            }
        }

        let currentFilterSelectedNode = currentFilter.filter(val => val.Name === refinerName)[0];
        let ensuredNextFilter = ensureSelectedFilterValues(nextFilter, currentFilterSelectedNode, refinerName);
        
        // If 0 results with filters, check if we should fall back to unfiltered results
        if (newResults.items.length === 0) {
            const hasUserFilters = this.hasUserSelectedFilters();
            if (hasUserFilters) {
                // User has actively chosen filters — show 0 results, no fallback
                this.setState({
                    results: newResults,
                    filter: ensuredNextFilter,
                    currentPageNumber: 1,
                    query: queryString,
                    querySuggestion: undefined,
                    previousFilters: newPreviousFiltersToSave,
                    searchWithoutFiltersHasResults: false,
                    isInitialSearch: false
                });
            } else {
                // Only predefined filters — fall back to unfiltered results
                const queryNoFilter: SearchQuery = {
                    queryString: queryString,
                    pageNumber: 1,
                    source: this.state.searchSource
                };
                const allResultsNoFilters = await getResults(queryNoFilter);
                if (allResultsNoFilters && allResultsNoFilters.totalResults > 0) {
                    // Fallback succeeded — clear predefined filter params from URL and
                    // strip checked state from refiners so the filter panel/chips don't
                    // render the predefined filters as still selected.
                    removeAllFilterParams(window.location.href, this.refinementFilters);
                    const unfilteredRefiners = (allResultsNoFilters.refiners || []).map(refiner => ({
                        ...refiner,
                        Entries: (refiner.Entries || []).map(entry => ({ ...entry, checked: false, fakeChecked: false }))
                    }));
                    this.setState({
                        results: allResultsNoFilters,
                        filter: unfilteredRefiners,
                        currentPageNumber: 1,
                        query: queryString,
                        searchboxQuery: queryString,
                        querySuggestion: undefined,
                        previousFilters: newPreviousFiltersToSave,
                        searchWithoutFiltersHasResults: true,
                        isInitialSearch: false,
                        initialFilters: undefined
                    });
                } else {
                    this.setState({
                        results: newResults,
                        filter: ensuredNextFilter,
                        currentPageNumber: 1,
                        query: queryString,
                        querySuggestion: undefined,
                        previousFilters: newPreviousFiltersToSave,
                        searchWithoutFiltersHasResults: false,
                        isInitialSearch: false
                    });
                }
            }
        } else {
            this.setState({
                results: newResults,
                filter: ensuredNextFilter,
                currentPageNumber: 1,
                query: queryString,
                querySuggestion: undefined,
                previousFilters: newPreviousFiltersToSave,
                searchWithoutFiltersHasResults: false,
                isInitialSearch: false
            });
        }
    }

    private async emptyFilters() {
        let refiners = this.state.filter
        if (refiners === undefined) {
            return
        }

        emptyFilterCheckboxes('.filterContainer');
        
        const filterParams = [...this.refinementFilters, ...[this.refinementFiltersShowAllValuesUrlParamName]];
        removeAllFilterParams(window.location.href, filterParams);

        // Clear state for initialFilters
        this.setState({
            initialFilters: undefined,
        });

        // Run the query without filters - pass empty array to avoid using state.filter
        const query = this.state.query ? this.state.query : "*";
        this.runQuery(query, false, this.state.searchSource, 1, []);
    }

    private onRemoveFilter = (filterName: string, filterValue: string) => {
        // Remove filter value from URL
        const currentValue = getUrlParameter(filterName);
        if (currentValue) {
            const newValue = currentValue
                .split(';')
                .filter(v => decodeURIComponent(v) !== filterValue && v !== filterValue)
                .join(';');
            setUrlParameter(window.location.href, filterName, newValue);
        }
        
        // Run the query with updated filters from URL, preserving filter panel
        const query = this.state.query ? this.state.query : "*";
        const urlFilters = getFilterParametersFromUrl(this.refinementFilters);
        this.runQuery(query, false, this.state.searchSource, 1, urlFilters, false, true);
    }

    private async onAllFilterClicked(refinerName: string) {
        let stateRefiners = this.state.filter;
        
        if (!stateRefiners) return;
        
        let allFilterClickedRefiner = stateRefiners.filter(refiner => refiner.Name === refinerName)[0];
        if (allFilterClickedRefiner !== undefined) {
            const somethingIsChecked = allFilterClickedRefiner.Entries.filter(entry => entry.checked === true).length > 0;
            if (somethingIsChecked) {
                allFilterClickedRefiner.Entries.forEach(refinerValue => {
                    refinerValue.checked = false;
                });
                setUrlParameter(window.location.href, refinerName, '');
                const query = this.state.query ? this.state.query : '';
                let urlFilters = getFilterParametersFromUrl(this.refinementFilters);
                this.runQuery(query, false, this.state.searchSource, 1, urlFilters);
            }
        }
    }

    private onSortChanged = (sortValue: string) => {
        // Re-run query with current filters preserved
        this.runQuery(
            this.state.query ? this.state.query : '', 
            false, 
            this.state.searchSource, // Keep current search source
            1, // Reset to first page
            this.state.filter, // Keep current filters
            false, // isInitialQuery
            true // preserveFilters - keep all filter options visible
        );
    }

    //Runs on Back button pressed
    private onStatePopped() {
        const newStateQuery = getUrlParameter(this.queryParameter);
        const initialPageNumber = getUrlParameter('page');
        const safeInitialPageNumber = initialPageNumber ? +initialPageNumber : 1;
        const filterParameters = getFilterParametersFromUrl(this.refinementFilters);

        //Set up variables properly (like in the constructor), and run the setupjob
        this.setState({
            newStateQuery: newStateQuery,
            initialQuery: newStateQuery,
            initialPageNumber: safeInitialPageNumber,
            initialFilters: filterParameters,
        }, () => {
            this.setupAndRunInitialQuery();
        });
    }

    private updateSearchSource(source: SearchSource) {
        let filter = this.state.filter ? this.state.filter : undefined;
        const query = this.state.query ? this.state.query : "";
        this.runQuery(query, false, source, 1, filter);
        const newUrlParam = source === SearchSource.All ? source : '';
        setUrlParameter(window.location.href, 'kilde', newUrlParam);
        this.setState({
            searchSource: source
        });
    }

    private _onWindowResize() {
        let currentDisplayFormat = getCurrentDisplayFormat();
        this.setState({ displayFormat: currentDisplayFormat });
    }
    private _onOrientationChange() {
        if (window.innerWidth === 1024) {
            this.setState({ displayFormat: DisplayFormat.Tablet });
        } else if (window.innerWidth === 768) {
            this.setState({ displayFormat: DisplayFormat.Desktop });
        }

    }

    /**
     * Returns true if any non-predefined filter params are set in the URL,
     * or if predefined filters have values different from their defaults.
     */
    private hasUserSelectedFilters(): boolean {
        const hasNonPredefinedFilters = this.refinementFilters
            .filter(name => !this.predefinedFilterNames.includes(name))
            .some(name => {
                const value = getUrlParameter(name);
                return value !== undefined && value.length > 0;
            });
        if (hasNonPredefinedFilters) return true;

        // Check if predefined filters have been changed from their defaults
        return this.predefinedFilterNames.some(name => {
            const value = getUrlParameter(name);
            const defaultValue = this.predefinedFilterDefaults[name];
            return value !== undefined && value.length > 0 && value !== defaultValue;
        });
    }

}
